module.exports = "/_next/static/media/53f0dd5b79787b5a8034ea918294b9e7.svg";